/** Collision-resistant client-side identifiers for fields, layouts, options and tabs. */
let counter = 0;

export function createId(prefix = 'df'): string {
  counter += 1;
  const random = Math.floor(Math.random() * 900000 + 100000);
  return `${prefix}${Date.now().toString(36)}${counter.toString(36)}${random}`;
}

export function createFieldName(type: string): string {
  return `${type.replace(/[^a-z0-9]/gi, '')}${Math.floor(Math.random() * 900000 + 100000)}`;
}
